<template>
  <div class="card">
    <form>
      <div class="card-header">
        <h3 class="card-title text-center">
          Bem vindo
        </h3>
        <div class="row social">
          <div class="col-md-6 col-xs-12">
            <button type="button" class="btn btn-fill btn-facebook" @click.prevent="entrarComSocial(providers.facebook)">
              <i class="ti-facebook"><span> Entrar com o Facebook</span></i>
            </button>
          </div>
          <div class="col-md-6 col-xs-12">
            <button type="button" class="btn btn-fill btn-google" @click.prevent="entrarComSocial(providers.google)">
              <i class="ti-google"><span> Entrar com o Google</span></i>
            </button>
          </div>
        </div>
        <hr class="hr-text" data-content="OU">
      </div>
      <div class="card-content">
        <div class="form-group">
          <label>Email</label>
          <input type="email"
                 id="email"
                 name="email"
                 placeholder="Inserir e-mail"
                 v-validate="modelValidations.email"
                 v-model.lazy="model.email"
                 class="form-control">
          <small class="text-danger" v-show="email.invalid">
            {{ getError('email') }}
          </small>
        </div>
        <div class="form-group">
          <label>Senha</label>
          <input type="password"
                 name="password"
                 placeholder="Inserir senha"
                 v-validate="modelValidations.password"
                 v-model="model.password"
                 class="form-control">
          <small class="text-danger" v-show="password.invalid">
            {{ getError('password') }}
          </small>
        </div>

      </div>
      <div class="card-footer text-center">
        <button type="submit" @click.prevent="validate" @keyup.enter.native="validate" class="btn btn-fill btn-info btn-wd">Entrar</button>
        <div class="row opcoes">
          <div class="col-md-6 col-xs-6">
            <router-link to="/cadastrar" tag="a">Cadastrar-se</router-link>
          </div>
          <div class="col-md-6 col-xs-6">
            <a class="esqueci-senha" @click.prevent="esqueciSenha">Esqueceu sua senha?</a>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import Swal from 'sweetalert2'
  import Autenticacao from '@/services/Autenticacao'

  export default {
    computed: {
      ...mapFields(['email', 'password'])
    },
    data () {
      return {
        providers: Autenticacao.providers,
        model: {
          email: '',
          password: ''
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          },
          password: {
            required: true,
            min: 8
          }
        }
      }
    },
    methods: {
      esqueciSenha () {
        if (!this.model.email) {
          Swal(
            'Redefinição de Senha',
            `Favor preencher o campo e-mail para solicitar a redefinição da senha!`,
            'error'
          )
        } else {
          Autenticacao.enviarRedefinicaoSenha(this.model.email)
            .then(() => {
              Swal(
                'Redefinição de Senha',
                `E-mail de redefinição enviado, favor verificar sua caixa de entrada!`,
                'success'
              )
            })
        }
      },
      entrarComSocial (provider) {
        Autenticacao.entrarComSocial(provider)
          .then(result => {
            this.$router.push({
              name: 'dashboard'
            })
          })
          .catch(error => console.error(error))
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.model, isValid)
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
.esqueci-senha {
  cursor: pointer;
}

.btn {
    border-radius: 0;
    width: 100%;
   
   .btn-info.login {
      width: 100%;
    }
  }

.row {
  &.social {
    margin: 15px 0;

    .btn.btn-fill {
      margin: 10px 0;
    }
  }

  &.opcoes {
    margin-top: 15px;
  
    a {
      font-weight: bolder;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/ValidationForms/LoginForm.vue